module.exports = __webpack_public_path__ + "static/img/315.4590ba7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/190926/315.jpg
// module id = WsHY
// module chunks = 0